<template>
  <v-container>
    <v-row wrap>
      <v-flex xs2>
        <v-btn
          color="orange"
          text
          large
          @click="$router.push({'name': 'Admin'})"
        >
          < Admin Home
        </v-btn>
      </v-flex>
      <v-flex xs8 class="text-center">
        <span class="mr-5 headline pa-2">Analytics</span>


      </v-flex>
      <v-flex xs2>
        <div style="display:inline">Total Cards: {{totalCount}}</div>


      </v-flex>
    </v-row>

    <v-row wrap>
      <v-flex xs4>
        <v-text-field outlined v-model="startDate" type="date" label="Start Date"></v-text-field>
      </v-flex>
      <v-flex xs4>
        <v-text-field outlined v-model="endDate" type="date" label="End Date"></v-text-field>
      </v-flex>
      <v-flex xs4>
        <v-select multiple outlined type="date" label="Cohort" :items="possibleCohorts" v-model="selectedCohorts"></v-select>
      </v-flex>
      <v-flex xs4>
        <v-btn @click="runQuery()">Query Data</v-btn>
      </v-flex>
      <v-flex xs8 v-if="cohortEngagement" class="text-right">
        <div v-for="(item, key) in cohortEngagement.cohortCounts" :key="key">
          <span>{{key}}: {{item}}</span>
        </div>



      </v-flex>
    </v-row>


    <v-layout row wrap>
      <v-flex xs12 md6>
        <v-card flat outlined class="ma-2 pa-2">
          <AnalytisUsageBar :key="AnalytisUsageBarKey" :chartData="AnalytisUsageBarData" :options="AnalytisUsageBarChartOptions" />
        </v-card>


      </v-flex>
      <v-flex xs12 md6>
        <v-card flat outlined class="ma-2 pa-2">
          <AnalytisUsageBar :key="UniqueUsersBarKey" :chartData="UniqueUsersBarData" :options="UniqueUsersBarChartOptions" />

        </v-card>


      </v-flex>
      <v-flex xs12>
        <v-card flat outlined class="ma-2 pa-2">
          <div class="title text-center">Decks Practiced</div>
          <v-layout row wrap>
            <v-flex xs1>

            </v-flex>
            <v-flex xs5>
              Deck
            </v-flex>
            <v-flex xs3 class="text-center">
              Cards Practiced
            </v-flex>
            <v-flex xs3 class="text-center">
              Users Used
            </v-flex>
          </v-layout>
          <v-card flat class="pa-1" v-if="decksWithPractice" v-for="i, key in decksWithPractice" :key="key">
            <v-layout row wrap>
              <v-flex xs1>

              </v-flex>
              <v-flex xs5>
                {{i.name}}
                <v-chip>{{i.subject}}</v-chip>
              </v-flex>
              <v-flex xs3 class="text-center">
                {{i.count}}
              </v-flex>
              <v-flex xs3 class="text-center">
                {{i.users}}
              </v-flex>
            </v-layout>
          </v-card>

        </v-card>


      </v-flex>




    </v-layout>
  </v-container>


</template>
<script>
import AnalytisUsageBar from '@/components/Analytics/AnalytisUsageBar.vue'
import firebase from 'firebase'
import moment from 'moment'
import _ from 'underscore'
export default {
  name: 'AdminAnalytics',
  components: {
    AnalytisUsageBar,
  },
  data() {
    return {
      cohortEngagement: null,
      totalCount: null,
      rawData: null,
      usage: null,
      startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      neuroUsage: null,
      selectedCohorts: [],
      possibleCohorts: ['ucd2026','ucd2025', 'ucd2024', 'ucd2023'],
      cohorts: null,
      deckNames: null,
      practiceColors: ['#FF5722','#FF9800', '#FFC107','#FFEB3B'],
      userColors: ['#3F51B5','#2196F3','#00BCD4', '#009688'],

      

      //ANALYTICS BAR
      AnalytisUsageBarData: {
        labels: ['Waiting for Query'],
        datasets: [
          {
            label: 'Waiting for Query',
            backgroundColor: '#FF9800',
            data: [0]
          },
        ]
      },
      AnalytisUsageBarChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
            display: true,
            text: 'Cards Practiced By Day',
            fontSize: 20
        },
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true
                }
            }]
        }
      },
      AnalytisUsageBarKey: 0,



      //UNIQUE USERS
      UniqueUsersBarData: {
        labels: ['Waiting for Query'],
        datasets: [
          {
            label: 'Waiting for Query',
            backgroundColor: '#42A5F5',
            data: [0]
          },
        ]
      },
      UniqueUsersBarChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
            display: true,
            text: 'Unique Users By Day',
            fontSize: 20
        },
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true
                }
            }]
        }

      },
      UniqueUsersBarKey: 0,

      //Practice
      decksWithPractice: null,


    }
  },
  mounted() {
    firebase.firestore().collection('metrics').doc('metrics').onSnapshot(doc => {
      let data = doc.data()
      this.totalCount = data.logs
    })


    let month = moment().get('month')
    let year = moment().get('year')
    month >= 5 ? year += 4 : year += 3
    let cohorts = []
    cohorts.push('other')
    cohorts.push('ucdIMresident')
    for (let i = 0; i <= year - 2023; i++) {
      cohorts.push('ucd' + (2023 + i))
    }
    this.possibleCohorts = cohorts.reverse()


  },
  methods: {
    runQuery() {
      this.getCohorts().then(() => {
        this.getDeckNames()
        return this.getDeckUsage()
      }).then(() => {
        this.segmentUse()
        this.segmentUser()
        this.segmentDecks()
        this.usersByCohort()
      })
    },
    retrieveData() {
      this.getDeckUsage().then(() => {
        this.segmentTotalUse()
        this.segmentNeuroUse()
        this.segmentUniqueUsers()
        this.segmentPopularDecks()
        this.segmentPopularDecks()
      })
    },
    getDeckNames() {
      return firebase.firestore().collection('deckPackages').doc('browse').get()
      .then(doc => {
        return this.deckNames = doc.data()
      })
    },
    getCohorts() {
      this.cohorts = {}
      return firebase.firestore().collection('users').get().then(snapshot => {
        snapshot.forEach(doc => {
          let data = doc.data()
          try {
            this.cohorts[doc.id] = data.cohorts[0] //limited to single cohort
          }
          catch(err) {
            console.log(err)
          }
        })
        return true
      })
    },


    getDeckUsage() {
      return firebase.firestore().collection('activityLog')
      .where('timestamp', '>', moment(this.startDate).toDate())
      .where('timestamp', '<=', moment(this.endDate).toDate())
      .get().then(snapshot => {
        this.rawData = {}
        snapshot.forEach(doc => {
          let ungrouped = []
          let data = doc.data()
          for (let item in data) {
            let entry = data[item]
            if (item != 'timestamp') {
              entry.forEach(x => {
                let formatedX = x
                formatedX.timestamp = moment(x.timestamp.toDate())
                formatedX.cohort = this.cohorts[formatedX.uid]
                ungrouped.push(formatedX)
              })
            }
          }
          ungrouped = _.sortBy(ungrouped, 'timestamp')
          this.rawData[doc.id] = ungrouped
        })
        return true
      })
    },

    segmentUse() {
      let date = [] //X-Axis for dates
      let dataSets = {} //Object to store cohorts for each date

      //make a spot for each cohort
      this.selectedCohorts.forEach(item => {
        dataSets[item] = [] //Make array to correspond to dates in date variable
      })

      for (let item in this.rawData) {
        date.push(item)
        let cohortCounts = _.countBy(this.rawData[item], 'cohort')

        this.selectedCohorts.forEach(item => {
          if (cohortCounts.hasOwnProperty(item)) {
            dataSets[item].push(cohortCounts[item]) // get the count for the day
          }
          else {
            dataSets[item].push(0) //or write zero for the day
          }
        })
      }
      this.AnalytisUsageBarData.labels = date
      this.AnalytisUsageBarData.datasets = []

      this.selectedCohorts.forEach(item => {
        this.AnalytisUsageBarData.datasets.push({
            label: item,
            backgroundColor: this.practiceColors[this.selectedCohorts.indexOf(item)],
            data: dataSets[item]
        })
      })
      this.AnalytisUsageBarKey += 1


    },

    segmentUser() {
      let date = [] //X-Axis for dates
      let dataSets = {} //Object to store cohorts for each date

      //make a spot for each cohort
      this.selectedCohorts.forEach(item => {
        dataSets[item] = [] //Make array to correspond to dates in date variable
      })

      for (let item in this.rawData) {
        date.push(item)
        let cohortCounts = {}
        let cohortGroups = _.groupBy(this.rawData[item], 'cohort')
        for (let group in cohortGroups) {
          cohortCounts[group] = Object.keys(_.groupBy(cohortGroups[group],'uid')).length
        }

        this.selectedCohorts.forEach(item => {
          if (cohortCounts.hasOwnProperty(item)) {
            dataSets[item].push(cohortCounts[item]) // get the count for the day
          }
          else {
            dataSets[item].push(0) //or write zero for the day
          }
        })
      }
      this.UniqueUsersBarData.labels = date
      this.UniqueUsersBarData.datasets = []

      this.selectedCohorts.forEach(item => {
        this.UniqueUsersBarData.datasets.push({
            label: item,
            backgroundColor: this.userColors[this.selectedCohorts.indexOf(item)],
            data: dataSets[item]
        })
      })
      this.UniqueUsersBarKey += 1
    },

    segmentDecks() {
      let allData = _.flatten(Object.values(this.rawData)).filter(item => {
        return this.selectedCohorts.includes(item.cohort)
      })
      let deckCounts = _.countBy(allData, 'deck')
      let userCounts = _.groupBy(allData, 'deck')
      for (let deck in userCounts) {
        userCounts[deck] = Object.keys(_.groupBy(userCounts[deck], 'uid')).length
      }

      let result = []
      for (let id in deckCounts) {
        try {
          result.push({
            name: this.deckNames[id].name,
            subject: this.deckNames[id].subject,
            count: deckCounts[id],
            users: userCounts[id]
          })
        }
        catch(err) {
          result.push({
            name: id,
            subject: 'unknown',
            count: deckCounts[id],
            users: userCounts[id]
          })
        }

      }
      result = _.sortBy(result, 'count').reverse()
      this.decksWithPractice = result


    },
    usersByCohort() {
      let allData = _.flatten(Object.values(this.rawData)).filter(item => {
        return this.selectedCohorts.includes(item.cohort)
      })
      let cohortGroups = _.groupBy(allData, 'cohort')
      let cohortCounts = {}
      for (let group in cohortGroups) {
        cohortCounts[group] = Object.keys(_.groupBy(cohortGroups[group],'uid')).length
      }
      this.cohortEngagement = {
        cohortCounts
      }

    },







    segmentPopularDecks() {
      let group = []
      for (let item in this.rawData) {
        group.push(this.rawData[item])
      }
      group = _.flatten(group)
      group = _.groupBy(group, item => {return item.deck})

      let counts = []
      for (let item in group) {
        counts.push({deck: item, count: group[item].length})
      }
      counts = _.sortBy(counts, 'count').reverse()

      firebase.firestore().collection('deckPackages').doc('browse').get()
      .then(doc => {
        let index = doc.data()
        counts.forEach(i => {
          if (i.deck != 'NeuroAtlas') {
            i.deck = index[i.deck].name + " | " + index[i.deck].subject
          }
        })
        this.decksWithPractice = counts

      })

    }

  }
}
</script>
<style>

</style>
